// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.section {
  width: 100%;
  height: 100%;
  background-color: #f2f2f2;
  display: flex;
}
.section .menu {
  width: 16.6666666667%;
  height: 100%;
  border-right: 1px solid #c5c5c5;
  display: flex;
  flex-direction: column;
}
.section .menu-item {
  display: flex;
  align-items: center;
  padding-left: 10px;
  height: 50px;
  border-bottom: 1px solid #c5c5c5;
  cursor: pointer;
}
.section .menu-item:hover, .section .menu-item.active {
  background: #c5c5c5;
}
.section .content {
  flex: 1;
  overflow: auto;
}`, "",{"version":3,"sources":["webpack://./src/app/shared/section.scss","webpack://./src/app/pages/users-fgjs/users-fgjs.component.scss"],"names":[],"mappings":"AAAA;EACI,WAAA;EACA,YAAA;EACF,yBAAA;EACA,aAAA;ACCF;ADAI;EACI,qBAAA;EACA,YAAA;EACA,+BAAA;EACA,aAAA;EACA,sBAAA;ACER;ADDQ;EACI,aAAA;EACA,mBAAA;EACA,kBAAA;EACA,YAAA;EACA,gCAAA;EACA,eAAA;ACGZ;ADFY;EAEI,mBAAA;ACGhB;ADCI;EACI,OAAA;EACA,cAAA;ACCR","sourcesContent":[".section {\r\n    width: 100%;\r\n    height: 100%;\r\n  background-color:#f2f2f2;\r\n  display: flex;\r\n    .menu {\r\n        width: calc(100% / 3 / 2 );\r\n        height: 100%;\r\n        border-right: 1px solid #c5c5c5;\r\n        display: flex;\r\n        flex-direction: column;\r\n        &-item {\r\n            display: flex;\r\n            align-items: center;\r\n            padding-left: 10px;\r\n            height: 50px;\r\n            border-bottom: 1px solid #c5c5c5;\r\n            cursor: pointer;\r\n            &:hover,\r\n            &.active {\r\n                background: #c5c5c5;\r\n            }\r\n        }\r\n    }\r\n    .content {\r\n        flex: 1;\r\n        overflow: auto;\r\n    }\r\n}\r\n",".section {\n  width: 100%;\n  height: 100%;\n  background-color: #f2f2f2;\n  display: flex;\n}\n.section .menu {\n  width: 16.6666666667%;\n  height: 100%;\n  border-right: 1px solid #c5c5c5;\n  display: flex;\n  flex-direction: column;\n}\n.section .menu-item {\n  display: flex;\n  align-items: center;\n  padding-left: 10px;\n  height: 50px;\n  border-bottom: 1px solid #c5c5c5;\n  cursor: pointer;\n}\n.section .menu-item:hover, .section .menu-item.active {\n  background: #c5c5c5;\n}\n.section .content {\n  flex: 1;\n  overflow: auto;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
